import { apiClient } from '@/lib/api-client'
import { Compensation } from '@shared/types/entities'

export interface CompensationTotals {
  totalEarned: number
  totalPending: number
  totalPaid: number
  totalHours: number
  totalRegistrations: number
}

export const compensationService = {
  async list(token: string): Promise<{ compensations: Compensation[]; totals: CompensationTotals }> {
    return await apiClient.get('/scouts/me/compensation', token)
  },
}
